<div id="privacy">
  <div class="container">
    <div class="d-flex justify-content-center mb-4">
      <app-logo [link]="DefualtPath"></app-logo>
    </div>
    <p class="header">PRIVACY POLICY</p>
    <p class="desc">&nbsp;</p>
    <p class="desc">Last Modified: January 30, 2024</p>
    <p class="desc">
      Silk Road LLC (&ldquo;<strong>Company</strong>&rdquo;) respects your
      privacy and are committed to protecting it through our compliance with
      this Privacy Policy (the &ldquo;<strong>Policy</strong>&rdquo;). The
      Policy describes how your personal information is collected, used, and
      shared when you visit or submit information on any website owned, managed
      or operated by Company or any of its affiliates, including but not limited
      to bidxsell.com (the &ldquo;<strong>Website</strong>&rdquo;).
    </p>
    <p class="desc">
      Please read the Policy carefully before you start to access or use the
      Website to understand our policies and practices regarding your
      information and how we will treat it. &nbsp;By accessing or using the
      Website, you acknowledge that you have read, understood, and agree to the
      Policy. If you do not want to agree to the Policy, you shall not access or
      use the Website.&nbsp;
    </p>
    <h1 class="title">CHANGES TO THE POLICY</h1>
    <p class="desc">
      Company may revise and update the Policy from time to time in its sole
      discretion in order to reflect, for example, changes to our practices or
      for other operational, legal, or regulatory reasons. All changes are
      effective immediately when we post them, and apply to all access to and
      use of the Website thereafter. &nbsp;Your continued use of the Website
      following the posting of revised Policy means that you accept and agree to
      the changes.
    </p>
    <h1 class="title">ELIGIBILITY</h1>
    <p class="desc">
      Our Website is not intended for users under 18 years of age. No one under
      age 18 may provide any information to the Website. We do not knowingly
      collect personal information from children under 18. If you are under 18,
      do not use or provide any information on this Website. If we learn we have
      collected or received personal information from a child under 18 without
      verification of parental consent, we will delete that information. If you
      believe we might have any information from or about a child under 18,
      please contact us via the Contact Form at
      <a href="mailto:support@bidxsell.com"
        >support&#64;bidxsell.com</a
      >.
    </p>
    <h1 class="title">
      INFORMATION WE COLLECT ABOUT YOU AND HOW WE COLLECT IT
    </h1>
    <p class="desc">
      The Policy applies to information we collect when you visit the Website
      and communicate with the Website, i.e., email, text and other electronic
      messages between you and the Website. &nbsp;We automatically collect
      certain information about your device, including information about your
      web browser, IP address, time zone, and some of the cookies installed on
      your device. As you browse the Website, we collect information about the
      individual web pages, information, products or services that you view,
      what websites or search terms referred you to the Website, information
      about how you interact with the Website, and information about your
      internet connection.
    </p>
    <p class="desc">
      We collect this information using the following technologies, which may be
      updated from time to time: (1) &ldquo;Cookies&rdquo; are data files that
      are placed on your device or computer and often include an anonymous
      unique identifier; (2) &ldquo;Log files&rdquo; track actions occurring on
      our website, and collect data including your IP address, browser type,
      Internet service provider, referring/exit pages, and date/time stamps; (3)
      &ldquo;Web beacons,&rdquo; &ldquo;tags,&rdquo; and &ldquo;pixels&rdquo;
      are electronic files used to record information about how you browse our
      website; and (4) &ldquo;Analytic Services&rdquo; track and record
      additional data about activity and traffic patterns on our website.
    </p>
    <p class="desc">
      Additionally, we collect this information when you provide it directly to
      us, including: (1) when you submit or attempt to submit a form through our
      website, namely, we collect certain information from you as outlined on
      the form, which may include your name, address, email address, social
      security number, and phone number and before or at the time of collecting
      the submitted information, we will identify the purposes for which
      information is being collected; (2) records and copies of your
      correspondence (including email addresses), if you contact Company; (3)
      details of transactions you carry out through the Website and of the
      fulfillment of your auction bids, namely, you will be required to provide
      financial or payment information (i.e., bank, credit card and/or wiring
      information) before placing a bid through our Website; and (4) any other
      types of information that you provide.
    </p>
    <p class="desc">
      Company stores information submitted and collected through the Website in
      the United States. The privacy protections in the United States may not be
      the same as in your home country. If you are located in a country outside
      the U.S. and you submit personal information to Company and/or use
      Website, you consent to the collection, use, and disclosure of personal
      information as provided in this Privacy Policy and to that information
      being transferred to, stored, and otherwise processed in the U.S.&nbsp;
    </p>
    <p class="desc">
      The Website may contain message boards, chat rooms, personal web pages or
      profiles, forums, bulletin boards, auctions, and other interactive
      features (collectively, &ldquo;<strong>Interactive Services</strong
      >&rdquo;) that allow users to post, bid, submit, publish, display, or
      transmit to Company or other users content or materials (collectively,
      &ldquo;<strong>User Contributions</strong>&rdquo;) on or through the
      Website. Your User Contributions are posted on and transmitted to others
      at your own risk. Although you may set certain privacy settings for such
      information by logging into your account profile, please be aware that no
      security measures are perfect or impenetrable. Additionally, we cannot
      control the actions of other users of the Website with whom you may choose
      to share your User Contributions. Therefore, we cannot and do not
      guarantee that your User Contributions will not be viewed by unauthorized
      persons.
    </p>
    <h1 class="title">HOW WE USE YOUR INFORMATION</h1>
    <p class="desc">
      We may use information that we collect about you or that you provide to
      us, including any personal information: (1) to fulfill any request placed
      through the Website (including contact requests, quote requests, and
      orders) including to communicate with you and provide you information or
      advertising relating to our products and services and other marketing
      purposes; (2) to help us screen for potential risk and fraud (in
      particular, your IP address), and more generally to improve and optimize
      the Website (for example, by generating analytics about how our customers
      browse and interact with our website, and to assess the success of our
      marketing and advertising campaigns); (3) to carry out our obligations and
      enforce our rights arising from any contracts entered into between you and
      us, including for billing and collection purposes such as those outlined
      in the Auction Terms and Conditions; (4) to notify you about changes to
      the Website or any products or services we offer or provide though it; (5)
      in any other way we may describe when you provide the information; (6) to
      fulfill any other purpose for which you provide it; and (7) for any other
      purpose with your consent.
    </p>
    <h1 class="title">DISCLOSURE OF YOUR INFORMATION</h1>
    <p class="desc">
      We may disclose aggregated information about our users without
      restriction.
    </p>
    <p class="desc">
      We may disclose personal information that we collect or you provide as
      described in Policy, including: (1) to our subsidiaries and affiliates;
      (2) to third parties to help us use your personal information as described
      in the previous section; (3) using third-party analytics to help us
      understand how our customers use the Website; (4) to a buyer or other
      successor in the event of a merger, divestiture, restructuring,
      reorganization, dissolution, or other sale or transfer of some or all of
      our assets, whether as a going concern or as part of bankruptcy,
      liquidation, or similar proceeding, in which personal information held by
      us about our Website users is among the assets transferred; (5) for
      marketing purposes; (6) for any other purpose disclosed by us when you
      provide the information; (7) with your consent; (8) to comply with
      applicable laws and regulations, to respond to a subpoena, search warrant
      or other lawful request for information we receive, or to otherwise
      protect our rights; (9) to enforce or apply the Terms of Use and other
      agreements, including for billing and collection purposes, such as those
      outlined in the Auction Terms and Conditions; and (10) if we believe
      disclosure is necessary or appropriate to protect the rights, property, or
      safety of us, our customers, or others.
    </p>
    <h1 class="title">CHOICES ABOUT THE USE OF YOUR INFORMATION</h1>
    <p class="desc">
      You have choices outlined below that you may exercise by contacting us via
      the Contact Form at
      <a href="mailto:support@bidxsell.com"
        >support&#64;bidxsell.com</a
      >:
    </p>
    <ul style="margin-bottom: 0in; margin-top: 0in" type="disc">
      <li class="li">
        <strong>Tracking Technologies and Advertising.</strong> You can set your
        browser to refuse all or some browser cookies, or to alert you when
        cookies are being sent. For more information, visit your browser&rsquo;s
        web settings. If you disable or refuse cookies, please note that some
        parts of this Website may then be inaccessible or not function properly.
      </li>
      <li class="li">
        <strong>Promotional Offers from the Company.</strong> If you do not wish
        to have your contact information used by the Company to promote our own
        or third parties&rsquo; products or services, you can opt-out by
        contacting us via the Contact Form at
        <a href="mailto:support@bidxsell.com"> support&#64;bidxsell.com</a
        >. If we have sent you a promotional email, you may send us a return
        email asking to be omitted from future email distributions.
      </li>
    </ul>
    <p class="desc">
      We do not control third parties&rsquo; collection or use of your
      information to serve interest-based advertising. However these third
      parties may provide you with ways to choose not to have your information
      collected or used in this way. You can opt out of receiving targeted ads
      from members of the Network Advertising Initiative
      (&ldquo;<strong>NAI</strong>&rdquo;) on the NAI&rsquo;s website.<br />&nbsp;Residents
      of certain states, such as California may have additional personal
      information rights and choices. Please see Your State Privacy Rights for
      more information.
    </p>
    <h1 class="title">ACCESSING AND CORRECTING YOUR INFORMATION</h1>
    <p class="desc">
      You can review and change your personal information by logging into the
      Website and visiting your account profile page.
    </p>
    <p class="desc">
      You may also contact us via the Contact Form at
      <a href="mailto:support@bidxsell.com"
        >support&#64;bidxsell.com</a
      >
      to request access to, correct or delete any personal information that you
      have provided to us. We may not accommodate a request to change
      information if we believe the change would violate any law or legal
      requirement or cause the information to be incorrect.
    </p>
    <p class="desc">
      If you delete your account or User Contributions from the Website, copies
      of your personal information related to your account or User Contributions
      may remain viewable in cached and archived pages, or might have been
      copied or stored by other Website users.
    </p>
    <p class="desc">
      Residents of certain states, such as California may have additional
      personal information rights and choices. Please see your State Privacy
      Rights for more information.
    </p>
    <p class="desc">YOUR STATE PRIVACY RIGHTS</p>
    <p class="desc">
      State consumer privacy laws may provide their residents with additional
      rights regarding our use of their personal information. Residents of
      certain states, such as California, may have additional personal
      information rights and choices. Please see your State Privacy Rights for
      more information. To learn more about California residents&rsquo; privacy
      rights, visit https://oag.ca.gov/privacy/ccpa. California&rsquo;s
      &ldquo;Shine the Light&rdquo; law (Civil Code Section &sect; 1798.83)
      permits users of our Website that are California residents to request
      certain information regarding our disclosure of personal information to
      third parties for their direct marketing purposes. To make such a request,
      please contact us via the Contact Form at
      <a href="mailto:support@bidxsell.com"
        >support&#64;bidxsell.com</a
      >.
    </p>
    <p class="desc">
      California law requires Company to disclose certain information relating
      to the categories of personal information collected from California
      residents, the sources from which the information was collected, the
      business purpose for which the information was collected, and to which
      type of parties the information is shared. The following table lists this
      information:
    </p>

    <div class="table-responsive">
      <table class="table">
        <!-- <table style="width: 5.0e+2pt;border: none;background:white;border-collapse:collapse;"> -->
        <thead>
          <tr>
            <th>Category of Personal Information</th>

            <th>Source of Collection</th>

            <th>Business Purpose</th>

            <th>To Whom Disclosed (categories)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Identifiers</td>
            <td>
              -you/your device<br />&nbsp;-technologically gathered from your
              operating systems and browsers<br />&nbsp;-service providers
            </td>
            <td>
              -marketing/ communications<br />&nbsp;-fulfill requests<br />&nbsp;-provide
              support<br />&nbsp;-process payments<br />&nbsp;-fulfill
              contractual obligations<br />&nbsp;-respond to inquiries
            </td>
            <td>
              -service providers<br />&nbsp;-distribution and fulfillment
              partners
            </td>
          </tr>
          <tr>
            <td>Customer Records</td>
            <td>-you</td>

            <td>
              -marketing/ communications<br />&nbsp;-fulfill requests<br />&nbsp;-provide
              support<br />&nbsp;-process payments<br />&nbsp;-fulfill
              contractual obligations<br />&nbsp;-respond to inquiries
            </td>
            <td>
              -service providers<br />&nbsp;-distribution and fulfillment
              partners
            </td>
          </tr>
          <tr>
            <td>Personal Characteristics</td>
            <td>n/a</td>
            <td>n/a</td>
            <td>n/a</td>
          </tr>
          <tr>
            <td>Commercial Information and Payment Transaction Information</td>
            <td>-you<br />&nbsp;-service providers</td>
            <td>
              -provide services to customers<br />&nbsp;- improve services<br />&nbsp;-fulfill
              contractual obligations<br />&nbsp;-respond to inquiries
            </td>
            <td>
              -service providers<br />&nbsp;-financial institutions<br />&nbsp;-government
              authorities and agencies<br />&nbsp;-credit agencies (when
              required by law)
            </td>
          </tr>
          <tr>
            <td>Internet Usage Information<</td>
            <td>
              -you/your device<br />&nbsp;-analytics and advertising partners
            </td>
            <td>
              -improve Website<br />&nbsp;-personalize Website<br />&nbsp;-improve
              customer experience<br />&nbsp;-marketing/<br />&nbsp;communications
            </td>
            <td>
              -service providers<br />&nbsp;-analytics and advertising partners
            </td>
          </tr>
          <tr>
            <td>Geolocation data</td>
            <td>
              -you/your device<br />&nbsp;-analytics and advertising partners
            </td>
            <td>
              -improve Website<br />&nbsp;-personalize Website<br />&nbsp;-improve
              customer experience<br />&nbsp;-marketing/<br />&nbsp;communications
            </td>
            <td>
              -service providers<br />&nbsp;-analytics and advertising partners
            </td>
          </tr>
          <tr>
            <td>Sensory data</td>
            <td>n/a</td>
            <td>n/a</td>
            <td>n/a</td>
          </tr>
          <tr>
            <td>Professional or employment-related information</td>
            <td>-you</td>
            <td>
            -respond to inquiries<br />&nbsp;-marketing/ communications
            </td>
            <td>-service providers</td>
          </tr>
          <tr>
            <td>Inferences drawn from other Personal Information</td>
            <td>
              -analytics and advertising partners<br />&nbsp;-service providers
            </td>
            <td>
              -marketing and remarketing<br />&nbsp;-improve customer experience
            </td>
            <td>-analytics and advertising partners</td>
          </tr>
        </tbody>
      </table>
      <p class="desc">&nbsp;</p>
      <p class="desc">
        If you are a California resident, in addition any other rights set forth
        herein, you may also exercise any of the following rights:
      </p>
      <ul style="margin-bottom: 0in; margin-top: 0in" type="disc">
        <li class="li">
          You may request information about Company&rsquo;s disclosure of your
          personal information to third parties for their direct marketing
          purposes.
        </li>
        <li class="li">
          Subject to certain exceptions, you may request that we delete personal
          information about you that we have collected and retained.&nbsp;
        </li>
        <li class="li">
          You have the right not to be discriminated against for exercising your
          rights under the CCPA.
        </li>
        <li class="li">
          You have the right opt-out of personal data processing for targeted
          advertising and sales.
        </li>
        <li class="li">
          You may designate an authorized agent to act on your behalf.
        </li>
      </ul>
      <p class="desc">
        Colorado, Connecticut, Virginia, and Utah each provide their state
        residents with rights to: (1) confirm whether we process their personal
        information; (2) access and delete certain personal information; (3)
        data portability; (4) opt-out of personal data processing for targeted
        advertising and sales.<br />Colorado, Connecticut, and Virginia also
        provide their state residents with rights to: (1) correct inaccuracies
        in their personal information, taking into account the
        information&apos;s nature processing purpose; (2) opt-out of profiling
        in furtherance of decisions that produce legal or similarly significant
        effects. To exercise any of these rights please contact us via the
        Contact Form at
        <a href="mailto:support@bidxsell.com"> support&#64;bidxsell.com</a
        >.
      </p>
      <h1 class="title">DATA SECURITY</h1>
      <p class="desc">
        The security of your personal information is important to us. We follow
        generally accepted industry standards to protect the personal
        information submitted to us and have implemented measures designed to
        secure your personal information from accidental loss and from
        unauthorized access, use, alteration, and disclosure including storing
        certain information behind firewalls and encryption is used for certain
        information.
      </p>
      <p class="desc">
        The safety and security of your information also depends on you. Where
        we have given you (or where you have chosen) a password for access to
        certain parts of the Website, you are responsible for keeping this
        password confidential. We ask you not to share your password with
        anyone. We urge you to be careful about giving out information in public
        areas of the Website. The information you share in public areas may be
        viewed by any user of the Website.
      </p>
      <p class="desc">
        Unfortunately, the transmission of information via the internet is not
        completely secure and the electronic storage of such information is not
        completely secure. Although we do our best to protect your personal
        information, we cannot guarantee the security of your personal
        information transmitted to our Website or third parties. Any
        transmission of personal information is at your own risk. We are not
        responsible for circumvention of any privacy settings or security
        measures contained on the Website.
      </p>
      <h1 class="title">DO NOT TRACK</h1>
      <p class="desc">
        Please note that we do not alter our website&rsquo;s data collection and
        use practices when we see a Do Not Track signal from your browser.
      </p>
      <h1 class="title">DATA RETENTION</h1>
      <p class="desc">
        When you submit a form through our website, we will retain and maintain
        the submitted information for our records unless and until you ask us to
        delete this information.
      </p>
      <h1 class="title">CONTACT INFORMATION</h1>
      <p class="desc">
        To ask questions or comment about this privacy policy and our privacy
        practices, contact us via the Contact Form at
        <a href="mailto:support@bidxsell.com"> support&#64;bidxsell.com</a
        >
      </p>
      <p class="desc">&nbsp;</p>
    </div>
  </div>
</div>
